import React, { useState } from 'react'
import PropTypes from 'prop-types'
import HotelAmenitiesModal from '../modals/HotelAmenitiesModal'
import { MFacility } from '../types'

const HotelAmenities = ({ amenities }) => {

  const [open, setOpen] = useState(false)

  const _displayAllAmenities = () => (
    <HotelAmenitiesModal
      open={open}
      amenities={amenities}
      toggleModal={_toggleModal}
    />
  )

  const _toggleModal = () => setOpen(!open)

  return (
    <div className="amenities">
      { amenities && <button className="button text" onClick={() => _toggleModal()}>View Amenities</button> }
      { amenities && _displayAllAmenities() }
    </div>
  )
}

HotelAmenities.propTypes = {
  amenities: PropTypes.arrayOf(MFacility)
}

export default HotelAmenities
